const isActiveElementRef = ref =>
  ref?.current && ref?.current === document.activeElement;

export default isActiveElementRef;
